import { IParamsGetUnit } from 'app/api/hr/model'
import { ParamsList } from 'parkway-web-common'

export const LocationKeys = {
  allAreas: ['Areas'] as const,
  listAreas: () => [...LocationKeys.allAreas, 'listAreas'] as const,
  getListArea: (filters?: ParamsList & IParamsGetUnit) =>
    [...LocationKeys.listAreas(), { filters }] as const,
}
